import { Component, HostListener } from "@angular/core";

@Component({
  templateUrl: "./postassessment.component.html"
})
export class PostAssessmentComponent {

  canDeactivate: boolean = true;

  constructor() {    
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (!this.canDeactivate) {
      $event.returnValue = true;
    }
  }

  setDeactivated(val: boolean) {
    this.canDeactivate = !val;
  }
}
